// Import minimal Ionic CSS needed for router/outlet + overlays only
// Do NOT import typography.css or normalize.css - those are style clobberers
import '@ionic/react/css/core.css';
import '@ionic/react/css/structure.css';
// Import Montserrat font locally (weights: 200, 300, 400, 500, 600, 700)
import '@fontsource/montserrat/200.css';
import '@fontsource/montserrat/300.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
// Import Tailwind CSS after Ionic (so Tailwind can override if needed)
import '@/styles/globals.css';
// Initialize API client early (side-effect import)
import '@/core/lib/api-client';

import React from 'react';
import { createRoot } from 'react-dom/client';

import { installDevPerf } from '@/core/dev/dev-perf';
import { useButtonHaptics } from '@/core/hooks/use-button-haptics';
import { useCapacitorInit } from '@/core/hooks/use-capacitor-init';
import { useCapacitorKeyboardInset } from '@/core/hooks/use-capacitor-keyboard-inset';
import { useKeyboardAwareInputScroll } from '@/core/hooks/use-keyboard-aware-input-scroll';
import { useThemeBootstrap } from '@/core/hooks/use-theme-bootstrap';
import { QueryProvider } from '@/core/providers/query-provider';
import { IonicRouterSetup } from '@/core/router/ionic-router-setup';
import { initPosthog } from '@/core/posthog-init';
import {
  applyViewportZoomPolicy,
  markNativeShellOnDocument,
} from '@/core/utils/capacitor.utils';

// Initialize PostHog early (no-op without a public key)
initPosthog();
installDevPerf();
markNativeShellOnDocument();
applyViewportZoomPolicy();

function App() {
  // Initialize theme and Capacitor (hooks handle side effects)
  useThemeBootstrap();
  useCapacitorInit();
  useCapacitorKeyboardInset();
  useKeyboardAwareInputScroll();
  useButtonHaptics();

  return <IonicRouterSetup />;
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <QueryProvider>
      <App />
    </QueryProvider>
  </React.StrictMode>,
);
